import { Observable, of, ReplaySubject, Subject } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { ServerTokensService } from '@core/services/server-tokens.service';
import { FooterMenuViewModel, MainMenuViewModel, MetaMenuLinkItemViewModel } from '@models/api.models';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class NavigationService implements OnDestroy {
    private readonly unsubscribe: Subject<void> = new Subject<void>();
    private readonly menuRs$: ReplaySubject<MainMenuViewModel> = new ReplaySubject<MainMenuViewModel>(1);
    private readonly metaMenuRs$: ReplaySubject<MetaMenuLinkItemViewModel[]> = new ReplaySubject<
        MetaMenuLinkItemViewModel[]
    >(1);
    private readonly footerMenuRs$: ReplaySubject<FooterMenuViewModel> = new ReplaySubject<FooterMenuViewModel>(1);
    public menu$ = this.menuRs$.asObservable();
    // KOP-2960 | Reversed the order of the meta menu links
    public metaMenu$ = this.metaMenuRs$.pipe(map(links => links.toReversed()));
    public footerMenu$ = this.footerMenuRs$.asObservable();

    constructor(
        private http: HttpClient,
        private serverTokenService: ServerTokensService
    ) {
        this.getMainMenu.subscribe(navigation => this.menuRs$.next(navigation));
        this.getMetaMenu.subscribe(navigation => this.metaMenuRs$.next(navigation));
        this.getFooterMenu.subscribe(navigation => this.footerMenuRs$.next(navigation));
    }

    private get getMainMenu(): Observable<MainMenuViewModel> {
        if (this.serverTokenService.navigationResponse) {
            return of(this.serverTokenService.navigationResponse);
        }
        return this.http.get<MainMenuViewModel>(`content/mainmenu`);
    }

    private get getMetaMenu(): Observable<MetaMenuLinkItemViewModel[]> {
        if (this.serverTokenService.metaNavigationResponse) {
            return of(this.serverTokenService.metaNavigationResponse);
        }
        return this.http.get<MetaMenuLinkItemViewModel[]>(`content/metamenu`);
    }

    private get getFooterMenu(): Observable<FooterMenuViewModel> {
        if (this.serverTokenService.footerNavigationResponse) {
            return of(this.serverTokenService.footerNavigationResponse);
        }
        return this.http.get<FooterMenuViewModel>(`content/footermenu`);
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
        this.menuRs$.complete();
    }
}
